import { render, staticRenderFns } from "./DISCOBJECT.list.component.vue?vue&type=template&id=e40785ac&"
import script from "./DISCOBJECT.list.component.vue?vue&type=script&lang=js&"
export * from "./DISCOBJECT.list.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports